import { useQuery } from 'react-apollo';

import getAlbumCustomPrint from '../../../graphql/queries/getAlbumCustomPrint';

const useStandaloneAlbumCustomPrintConfigurator = ({ albumCustomPrintId }) => {
  const { data: { albumCustomPrint } = {}, loading } = useQuery(
    getAlbumCustomPrint,
    {
      variables: {
        id: albumCustomPrintId,
      },
    },
  );
  return {
    loading,
    albumCustomPrint,
  };
};

export default useStandaloneAlbumCustomPrintConfigurator;
